/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DOCUMENT, Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {adsBlocked} from '../../../errors/ads-blocked';
import {WINDOW} from '../../../angular-platform-providers';

@Component({
  imports: [CommonModule],
  selector: 'adn-ghostery-banner',
  template: `
    <div class="warningBanner blockedBanner" *ngIf="!forceOff && ghostery">
      <p style="font-size: 25px">Ad Blocking Detected</p>
      <p>We've detected that your browser is blocking scripts that are necessary for this application.</p>
      <p>You may need to disable any Ad Blocking and/or Privacy browser extensions for this site and refresh the page to ensure the application works as expected.</p>
      <p><a (click)="forceOff = true"><span class="fa fa-times-circle"></span> Turn this warning off</a></p>
    </div>
  `
})
export class GhosteryBannerComponent implements OnInit {
  ghostery = false;
  forceOff = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window: any
  ) {
  }

  ngOnInit(): void {
    const checkVisibility = () => {
      setTimeout(() => {
        this.ghostery = !this.forceOff && adsBlocked();
      }, 100);
    };

    if (this.document.readyState === 'complete') {
      checkVisibility();
    } else {
      this.window.onload = checkVisibility;
    }
  }
}
